import { Routes } from '@angular/router';
import { authGuard, guestGuard, onboardingGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [guestGuard],
    children: [
      { path: 'login', loadComponent: () => import('./features/auth/login/login.component').then((m) => m.LoginComponent) },
      { path: 'register', loadComponent: () => import('./features/auth/register/register.component').then((m) => m.RegisterComponent) },
      { path: '', redirectTo: 'login', pathMatch: 'full' },
    ],
  },
  {
    path: 'onboarding',
    canActivate: [onboardingGuard],
    loadComponent: () => import('./features/onboarding/onboarding.component').then((m) => m.OnboardingComponent),
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () => import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
  },
  {
    path: 'calendar',
    canActivate: [authGuard],
    loadComponent: () => import('./features/calendar/calendar.component').then((m) => m.CalendarComponent),
  },
  {
    path: 'symptoms',
    canActivate: [authGuard],
    loadComponent: () => import('./features/symptoms/symptoms.component').then((m) => m.SymptomsComponent),
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () => import('./features/profile/profile.component').then((m) => m.ProfileComponent),
  },
  {
    path: 'settings',
    canActivate: [authGuard],
    loadComponent: () => import('./features/settings/settings.component').then((m) => m.SettingsComponent),
  },
  {
    path: 'install-guide',
    loadComponent: () => import('./features/ios-install-guide/ios-install-guide.component').then((m) => m.IosInstallGuideComponent),
  },
  {
    path: '',
    loadComponent: () => import('./features/loading-screen/loading-screen.component').then((m) => m.LoadingScreenComponent),
  },
  { path: '**', redirectTo: '' },
];